import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    bigNumber: {
      fontSize: 25,
      fontWeight: 500,
      lineHeight: 0.8,
      margin: '15px 5px 0px 0px',
    },
    bigNumberSuperAdmin: {
      color: palette.navSuperAdminActions,
    },
    bigNumberAdmin: {
      color: palette.navAdminActions,
    },
    bigNumberOperator: {
      color: palette.navOperatorActions,
    },
    bigNumberCompanyContext: {
      color: palette.navCompanyContextActions,
    },
    littleNumber: { fontSize: 15, fontWeight: 500 },
    savings: {
      fontSize: 24,
      fontWeight: 500,
      marginRight: 5,
      lineHeight: 0.8,
    },
    savingsSuperAdmin: {
      color: palette.navSuperAdminActions,
    },
    savingsAdmin: {
      color: palette.navAdminActions,
    },
    savingsOperator: {
      color: palette.navOperatorActions,
    },
    savingsCompanyContext: {
      color: palette.navCompanyContextActions,
    },
    title: {
      fontSize: 12,
      fontWeight: 500,
      marginLeft: 7,
      color: palette.darkGray,
    },
    content: { alignItems: 'end' },
    iconGrid: {
      marginInline: '7px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      height: 20,
    },
    monthlySavings: {
      marginTop: 15,
    },
    monthlyText: {
      fontSize: 15,
      fontWeight: 500,
      lineHeight: 0.8,
    },
    annualSavings: {
      display: 'flex',
      justifyContent: 'flex-end',
      fontSize: 9,
    },
  });

export const overrideCard = breakpoints => {
  const overrideStyles = {
    alignItems: 'center',
    display: 'flex',
    minHeight: 100,
    width: 300,
    minWidth: 300,
    border: `1px solid ${palette.greyCardBorder}`,
    [breakpoints.down(575)]: {
      width: 250,
      minWidth: 250,
    },
    '&:after': {
      content: '""',
      position: 'absolute',
      width: 160,
      height: 168,
      borderRadius: '50%',
      zIndex: 1,
      top: -74,
      right: -139,
      opacity: 0.5,
    },
    '&:before': {
      content: '""',
      position: 'absolute',
      zIndex: 1,
      width: 150,
      height: 180,
      borderRadius: '50%',
      top: -135,
      right: -89,
      opacity: 0.5,
    },
  };

  return overrideStyles;
};
